import type { useEffect } from 'react';
import { useLayoutEffect } from 'react';
import { useAsync } from 'react-streaming';

import { IS_SERVER } from '../ssr';

/** In SSR, we use useAsync, which throws the promise until it is finished */
export const useAsyncOrLayoutEffect: <T>(
  a: Parameters<typeof useEffect>[1],
  b: () => T,
) => Awaited<T> | void = IS_SERVER
  ? useAsync
  : (a: Parameters<typeof useEffect>[1], b: Parameters<typeof useAsync>[1]) => {
      // biome-ignore lint/correctness/useExhaustiveDependencies(b): Doesn't change
      useLayoutEffect(() => {
        b();
      }, a);
    };
